module.exports = __webpack_public_path__ + "img/bot-avatar.c1ab0165.png";